import { render, staticRenderFns } from "./swipingCard.vue?vue&type=template&id=57372a42&scoped=true"
import script from "./swipingCard.vue?vue&type=script&lang=js"
export * from "./swipingCard.vue?vue&type=script&lang=js"
import style0 from "./swipingCard.vue?vue&type=style&index=0&id=57372a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57372a42",
  null
  
)

export default component.exports